import React, { useState } from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

export const LegacyBadge = ({ api, appraisalId, legacy, onChange }) => {
  const [busy, setBusy] = useState(false);
  if (!legacy?.is_legacy) return null;
  const mark = async (evaluated) => {
    setBusy(true);
    try {
      await api.post(`/appraisals/${appraisalId}/legacy-evaluated`, { evaluated });
      toast.success(evaluated ? 'Marked as evaluated' : 'Back on the evaluation list');
      onChange();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not save'); }
    finally { setBusy(false); }
  };
  if (legacy.evaluated_at) {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-600" data-testid="legacy-evaluated-badge">
        <CheckCircle2 size={11} /> Legacy · evaluated by {legacy.evaluated_by || 'staff'}
        <button data-testid="legacy-unevaluate-btn" disabled={busy} onClick={(e) => { e.stopPropagation(); mark(false); }} className="ml-1 underline hover:text-rose-600">undo</button>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-900 border border-amber-300" title={legacy.reason} data-testid="legacy-needs-eval-badge">
      <AlertTriangle size={11} /> Legacy · Needs evaluation
      <button data-testid="legacy-mark-evaluated-btn" disabled={busy} onClick={(e) => { e.stopPropagation(); mark(true); }} className="ml-1 font-normal underline hover:text-emerald-700">mark evaluated</button>
    </span>
  );
};
